import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { env } from '@/env';
import { VaultRole } from '@/modules/api/codegen';
import { StaticModal, useModal } from '@/modules/modals';
import { Dropdown } from '@/modules/ui';

import { useExportVault, useVaults } from '../../hooks';
import { selectActiveVaultId } from '../../services/selectors';
import type { VaultImportModalData } from '../../types';

// Import and export are a vault editor's rights, and the personal vault reports its owner as editor,
// so one check covers both vault types. Neither exists in the demo, like the company-wide pair.
export const VaultActions = () => {
    const activeVaultId = useSelector(selectActiveVaultId);
    const { vaults } = useVaults();

    const { mutate: exportVault, isPending: isExporting } = useExportVault();
    const { updateModal: openImport } = useModal<VaultImportModalData>(StaticModal.VAULT_IMPORT, { autoClose: true });

    const vault = vaults.find(({ id }) => id === activeVaultId);

    if (env.VITE_DEMO || !vault || vault.userRole !== VaultRole.editor) {
        return null;
    }

    return (
        <Dropdown
            items={[
                {
                    key: 'export',
                    active: false,
                    disabled: isExporting,
                    label: <FormattedMessage id='vaults.actions.export' />,
                    onClick: () => exportVault(vault),
                },
                {
                    key: 'import',
                    active: false,
                    label: <FormattedMessage id='vaults.actions.import' />,
                    onClick: () => openImport(true, { vault }),
                },
            ]}
        >
            <FormattedMessage id='vaults.actions.title' />
        </Dropdown>
    );
};
